import {EventProvider} from './event-provider';
import {Session} from './session';
import {SessionType} from './enum/session-type';
import {SessionFactoryEvent} from './enum/session-factory-event';
import {ConnectionEvent} from './enum/connection-event';
import {RedirectionsRequest} from './redirections-request';
import {ConnectionState} from './enum/connection-state';
import {ConnectionPropertiesRejectedError} from './connection-properties-rejected-error';
import {ConnectionPropertiesRejectedReason} from './enum/connection-properties-rejected-reason';
import {ConnectionProperties} from './connection-properties';
import {Bookmark} from './bookmark';
import {TrustedCollectionsService} from '../trusted-collections.service';
import {ConnectionFactory} from './connection-factory';
import {Logger} from './logger';
import {RdpConnection} from './rdp-connection';

export class SessionFactory {
    private e: any = {};
    events = new EventProvider();

    constructor(private a: ConnectionFactory,
                private b: Logger,
                // private rdFeedTracker: any,
                private trustedCollections: TrustedCollectionsService) {
        // this.events.subscribe(SessionFactoryEvent.RedirectionsRequest, (aa: any) => {
        //     aa.a.complete(aa.properties, true);
        // });
    }

    private onWindowCreated = (a: any, c: any): void => {
        let d: Session;
        d = new Session(null, a, SessionType.RemoteApp, this.b), d.windowId = c,
            this.e[c] = d.id, this.events.fireEventCallback(SessionFactoryEvent.SessionCreated, d);
    };

    private onWindowDeleted = (a: any): void => {
        const c = this.e[a];
        c && (this.b.log('[SessionFactory] Connection destroyed window'), delete this.e[a], this.events.fireEventCallback(SessionFactoryEvent.SessionDestroyed, c));
    };

    private onWindowActivated = (a: any): void => {
        const c = this.e[a];
        console.debug('(SessionFocused)');
        console.debug(a);
        c && (this.b.log('[SessionFactory] Connection activated window'), this.events.fireEventCallback(SessionFactoryEvent.SessionFocused, c));
    };

    private onConnectionDestroyed = (a: RdpConnection): void => {
        this.events.fireEventCallback(SessionFactoryEvent.ConnectionDestroyed, a),
            a.events.unsubscribe(ConnectionEvent.ConnectionDestroyed, this.onConnectionDestroyed),
            a.events.unsubscribe(ConnectionEvent.WindowDeleted, this.onWindowDeleted),
            a.events.unsubscribe(ConnectionEvent.WindowActivated, this.onWindowActivated),
            a.events.unsubscribe(ConnectionEvent.WindowCreated, this.onWindowCreated);
    };

    private k = (a: any, c: ConnectionProperties): void => {
        this.b.log('[SessionFactory] Redirections request');
        const d = new RedirectionsRequest(a, c);
        this.events.fireEventCallback(SessionFactoryEvent.RedirectionsRequest, d);
    };

    completeConnectionCreation(a: RdpConnection, c: ConnectionProperties, rememberCollection: boolean, bookmark: Bookmark, hadSuccessfulConnection: boolean): void {
        let m: Session = null;
        // bookmark.rdpConnection = a;
        a.isExistingConnection || (this.events.fireEventCallback(SessionFactoryEvent.ConnectionCreated, bookmark.id, a)),
        this.trustedCollections && rememberCollection && (this.b.debug('[SessionFactory] Trusting collection'), this.trustedCollections.trustCollection(c)),
            a.events.subscribe(ConnectionEvent.ConnectionDestroyed, this.onConnectionDestroyed),
            c.remoteApplicationMode ? (this.b.debug('[SessionFactory] Launching remote app: ' + c.remoteApplicationProgram),
                a.events.subscribe(ConnectionEvent.WindowCreated, this.onWindowCreated),
                a.events.subscribe(ConnectionEvent.WindowDeleted, this.onWindowDeleted),
                a.events.subscribe(ConnectionEvent.WindowActivated, this.onWindowActivated),
            hadSuccessfulConnection || a.launchApplication(c.remoteApplicationProgram, c.remoteApplicationCmdLine, ''),
            a.getState() !== ConnectionState.Connected && (bookmark.desktopName = bookmark.workspaceName, m = new Session(bookmark, a, SessionType.Desktop, this.b),
                this.events.fireEventCallback(SessionFactoryEvent.SessionCreated, m))) : (m = new Session(bookmark, a, SessionType.Desktop, this.b),
                this.events.fireEventCallback(SessionFactoryEvent.SessionCreated, m));
    }

    createSession(bookmark: Bookmark, hadSuccessfulConnection: boolean, remoteAppId: number): void {
        const h = (b: ConnectionProperties, rememberCollection: boolean): any => {
            try {
                this.a.createConnection(b, (a: RdpConnection): void => {
                    this.completeConnectionCreation(a, b, rememberCollection, bookmark, hadSuccessfulConnection);
                }, remoteAppId);
            } catch (a) {
                return void (b.connectionSettings.UseGatewayProtocol ? this.events.fireEventCallback(SessionFactoryEvent.ConnectionCreateFailed, a) :
                    this.events.fireEventCallback(SessionFactoryEvent.ConnectionCreateFailed,
                        new ConnectionPropertiesRejectedError(ConnectionPropertiesRejectedReason.GatewayNotSpecified, bookmark)));
            }
        };
        if (bookmark) {
            if (bookmark.rdpFileString) {
                const i = new ConnectionProperties(bookmark),
                    j = i.connectionSettings.EnableClipboard,
                    l = this.a.findConnection(i);
                bookmark.connectionProperties = i;
                i.connectionSettings.EnablePrinting = true;
                if (i.gatewayHostName ||
                (i.connectionSettings.UseGatewayProtocol = !1, i.connectionSettings.UseSecureWebSockets = !0,
                    i.connectionSettings.GatewayHostName = i.hostName, i.connectionSettings.GatewayPort = 3392, i.connectionSettings.GatewayPath = 'rdp'),
                !j || l && l.getState() !== ConnectionState.Disconnected || this.trustedCollections && this.trustedCollections.isCollectionTrusted(i)) {
                    h(i, !1);
                } else {
                    const m = {
                        complete: h,
                        cancel: (): void => {
                            this.b.error('[SessionFactory] Redirection confirmation cancelled');
                        }
                    };
                    this.k(m, i);
                }
            } else {
                // this.b.debug('[SessionFactory] Retrieving RDP file: ' + bookmark.rdpFileURL), this.rdFeedTracker.getFeedFile(bookmark.rdpFileURL).then((a: any): void => {
                //     bookmark.rdpFileString = a.data, this.createSession(bookmark, g);
                // }, (a: any): void => {
                //     const b: any = new Error('Retrieving the RDP file for the connection failed.');
                //     b.httpResponse = a, this.events.fireEventCallback(SessionFactoryEvent.ConnectionCreateFailed, b);
                // });
            }
        }
    }
}

